import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'city',
        loadChildren: () => import('./modules/cityModule/city.module').then(m => m.CityModule)
      },
      {
        path: 'tour',
        loadChildren: () => import('./modules/tour/tour.module').then(m => m.TourModule)
      },
      {
        path: 'myOpinions',
        loadChildren: () => import('./modules/my-opinions/my-opinions.module').then(m => m.MyOpinionsModule)
      },
      {
        path: 'thanksReview',
        loadChildren: () => import('./modules/thanks-review/thanks-review.module').then(m => m.ThanksReviewModule)
      },
      {
        path: 'ticket',
        loadChildren: () => import('./modules/ticket/ticket.module').then(m => m.TicketModule)
      },
      {
        path: 'hotel',
        loadChildren: () => import('./modules/hotel/hotel.module').then(m => m.HotelModule)
      },
      {
        path: 'flight',
        loadChildren: () => import('./modules/flight/flight.module').then(m => m.FlightModule)
      },
      {
        path: 'car',
        loadChildren: () => import('./modules/car/car.module').then(m => m.CarModule)
      },
      {
        path: 'transfer',
        loadChildren: () => import('./modules/transfer/transfer.module').then(m => m.TransferModule)
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
